export default __webpack_public_path__ + "maps-examples-default-callout-thumbnail-960-1bab0f81625ed2712d368d1c62d066d6.webp";